import { render, staticRenderFns } from "./pointList.vue?vue&type=template&id=9cbcba7c&scoped=true&"
import script from "./pointList.vue?vue&type=script&lang=ts&"
export * from "./pointList.vue?vue&type=script&lang=ts&"
import style0 from "./pointList.vue?vue&type=style&index=0&id=9cbcba7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbcba7c",
  null
  
)

export default component.exports